module.exports = __webpack_public_path__ + "fonts/romano_b7b34fcfdb09ba6c0acc1479ecbeb7d5.ttf";